import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material/";
import CleansingMenu from "../Products/Product/Menu/CleansingMenu";
import { useLocation } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Rating from "@mui/material/Rating";
import Alert from "@mui/material/Alert";
import { HashLink } from "react-router-hash-link";
import {
  storage,
  ref,
  uploadBytes,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
  addDoc,
  collection,
  db,
  serverTimestamp,
  updateDoc,
  doc,
  setDoc,
} from "../../firebase";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { getDoc } from "firebase/firestore";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const LeaveAReview = () => {
  const { t, i18n } = useTranslation();
  let currentLocation = JSON.parse(
    window.sessionStorage.getItem("iplookup")
  ).countryCode;

  currentLocation = "KO";

  const [value, setValue] = React.useState(5);

  const [imageUrl, setImageUrl] = useState(undefined);
  const [imageUrl2, setImageUrl2] = useState(undefined);
  const [imageUrl3, setImageUrl3] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);
  const [title, setTitle] = useState(null);
  const [comment, setComment] = useState(null);
  const { currentUser } = useAuth();
  let navigate = useNavigate();

  // console.log(currentUser.metadata.createdAt);

  let query = useQuery();
  let name = query.get("name");
  let link = query.get("link") + "#top";
  console.log("name", name);

  let productId = query.get("productId");
  console.log(name);
  console.log(productId);

  const removeImage = (url) => {
    // Create a reference to the file to delete
    const desertRef = ref(storage, url);

    // Delete the file
    deleteObject(desertRef)
      .then(() => {
        if (url === imageUrl) {
          setImageUrl(undefined);
        } else if (url === imageUrl2) {
          setImageUrl2(undefined);
        } else {
          setImageUrl3(undefined);
        }
      })
      .catch((error) => {
        // Uh-oh, an error occurred!
      });
  };

  const upload = async (fileName) => {
    setLoading(true);
    const random = Math.floor(Math.random() * 100000000000000);
    const path = productId + "/";

    const storageRef = ref(storage, path + random);

    const uploadTask = uploadBytesResumable(storageRef, fileName);

    // Register three observers:
    // 1. 'state_changed' observer, called any time the state changes
    // 2. Error observer, called on failure
    // 3. Completion observer, called on successful completion
    await uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
        }
      },
      (error) => {
        // Handle unsuccessful uploads
      },
      () => {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          // if (
          //   imageUrl !== undefined &&
          //   imageUrl2 !== undefined &&
          //   imageUrl3 !== undefined
          // ) {
          //   alert("Maximum number of photo is 3.");
          // }
          if (imageUrl === undefined) {
            setImageUrl(downloadURL);
          } else if (imageUrl2 === undefined) {
            setImageUrl2(downloadURL);
          } else if (imageUrl3 === undefined) {
            setImageUrl3(downloadURL);
          } else {
            setAlert("Maximum number of photo is 3.");
          }

          console.log("File available at", downloadURL);
        });
      }
    );
    setLoading(false);
  };
  const submit = async (e) => {
    e.preventDefault();
    console.log(value); // rating

    //timestamp: serverTimestamp()
    if (title && comment) {
      // Add a new document with a generated id.
      const dbName = currentLocation + "_" + "reviews_" + productId;

      let fn = "";
      let ln = "";
      let firstCharacterOfFirstname;

      const userRef = doc(db, "users", currentUser.uid);
      const docSnap = await getDoc(userRef);

      if (docSnap.exists()) {
        fn = docSnap.data().firstname;
        firstCharacterOfFirstname = fn.charAt(0);
        ln = docSnap.data().lastname;

        let data;
        if (docSnap.data().reviews) {
          data = docSnap.data().reviews;
          data.push(dbName);
        } else {
          data = [dbName];
        }

        const userRef = doc(db, "users", currentUser.uid);
        setDoc(userRef, { reviews: data }, { merge: true });
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }

      // put review to review db

      let images = [];
      if (imageUrl !== undefined) {
        images.push(imageUrl);
      }
      if (imageUrl2 !== undefined) {
        images.push(imageUrl2);
      }
      if (imageUrl3 !== undefined) {
        images.push(imageUrl3);
      }
      const docRef = await addDoc(collection(db, dbName), {
        title: title,
        comment: comment,
        rating: value,
        created: serverTimestamp(),
        images: images,
        uid: currentUser.uid,
        name: currentUser.email,
        type: "original",
      });
      console.log("Document written with ID: ", docRef.id);
      handleClickOpen();
      // navigate(`/product/${link}`);
      // window.scrollTo(0, 0);
    }
  };

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    navigate(`/product/${link}`);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <div>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
          >
            제품의 후기를 남겨주셔서
            감사합니다&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <Typography gutterBottom>
              저희 쇼핑몰을 이용해주신 고객님께 진심으로 감사드립니다.
            </Typography>
            {/* <Typography gutterBottom>
              Praesent commodo cursus magna, vel scelerisque nisl consectetur
              et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
              auctor.
            </Typography> */}
            <Typography gutterBottom>
              저희 헤즐릿은 고객님의 만족을 위해서 최선을 다하겠습니다. 창이
              닫히면 다시 상품페이지로 이동합니다.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleClose}>
              상품으로 돌아가기
            </Button>
          </DialogActions>
        </BootstrapDialog>
      </div>
      <Grid container sx={{ px: { md: 10, sm: 5, xs: 5 }, mb: 10 }}>
        <CleansingMenu />
        <Grid
          item
          md={8}
          sm={12}
          xs={12}
          sx={{ pb: 2, pt: 2, display: "flex", flexDirection: "column" }}
        >
          <Box
            sx={{
              pt: 3,
              pb: 3,
              fontSize: "13px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <HashLink to={"/product/" + link + "#top"}>
              <KeyboardBackspaceIcon sx={{ paddingTop: "3px" }} />
            </HashLink>
            <HashLink to={"/product/" + link + "#top"}>
              &nbsp;{t("Go back to the product")}
            </HashLink>
          </Box>
          <Box sx={{ pt: 2, fontSize: "18px", color: "gray" }}>
            <span style={{ color: "#153a5a", fontWeight: 600 }}>{t(name)}</span>{" "}
            {t("Review this item")}
          </Box>

          <Box sx={{ pt: 5, fontSize: "25px", pb: 3, color: "gray" }}>
            <Typography component="legend">
              {t("Change the review star")}
            </Typography>
            <Rating
              name="simple-controlled"
              value={value}
              sx={{ fontSize: "32px" }}
              onChange={(event, newValue) => {
                setValue(newValue);
              }}
            />
          </Box>
          <TextField
            id="filled-basic"
            label={t("Review Title*")}
            variant="filled"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            sx={{ width: { md: 2 / 3 }, mt: 2 }}
          />
          <TextField
            placeholder={t("Provide a brief description*")}
            multiline
            variant="filled"
            rows={8}
            maxRows={8}
            sx={{ width: { md: 2 / 3 }, mt: 2 }}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
          <Box sx={{ py: 3, pt: 4, color: "gray" }}>
            {t("Upload image(s) - maximum 3 images")}
          </Box>
          <input
            type="file"
            onChange={(e) => {
              upload(e.target.files[0]);
            }}
            style={{ width: "300px", cursor: "pointer" }}
          />
          {alert && (
            <Alert sx={{ width: "400px", mt: 2 }} severity="warning">
              {alert}
            </Alert>
          )}
          <Box sx={{ display: "flex" }}>
            {imageUrl && (
              <Box
                sx={{
                  pt: 2,
                  pr: 2,
                  display: "flex",
                  flexDirection: "column",
                  width: "100px",
                  // border: "1px solid black",
                  alignItems: "center",
                  color: "gray",
                }}
              >
                {imageUrl && (
                  <img src={imageUrl} alt="" width="100" height="100" />
                )}
                <Box
                  onClick={() => removeImage(imageUrl)}
                  sx={{ cursor: "pointer" }}
                >
                  {t("Remove")}
                </Box>
              </Box>
            )}

            {imageUrl2 && (
              <Box
                sx={{
                  pt: 2,
                  pr: 2,
                  display: "flex",
                  flexDirection: "column",
                  width: "100px",
                  // border: "1px solid black",
                  alignItems: "center",
                  color: "gray",
                }}
              >
                <img src={imageUrl2} alt="" width="100" height="100" />
                <Box
                  onClick={() => removeImage(imageUrl2)}
                  sx={{ cursor: "pointer" }}
                >
                  {t("Remove")}
                </Box>
              </Box>
            )}
            {imageUrl3 && (
              <Box
                sx={{
                  pt: 2,
                  pr: 2,
                  display: "flex",
                  flexDirection: "column",
                  width: "100px",
                  // border: "1px solid black",
                  alignItems: "center",
                  color: "gray",
                }}
              >
                <img src={imageUrl3} alt="" width="100" height="100" />
                <Box
                  onClick={() => removeImage(imageUrl3)}
                  sx={{ cursor: "pointer" }}
                >
                  {t("Remove")}
                </Box>
              </Box>
            )}
          </Box>
          <button
            onClick={(e) => submit(e)}
            className="custom_btn"
            style={{ width: "300px", marginTop: "30px" }}
          >
            {t("Submit")}
          </button>
        </Grid>
      </Grid>
    </>
  );
};

export default LeaveAReview;
